<template>
    <div class="modal-invoice">
        <SOSlotModal :modal-title="getTitle" :modal-id="modalId" :no-padding="true" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-20">
                    <div class="m-d-8">
                        <SOInformation
                            title="<span class='f-c-midgrey'>Pesan pengingat dikirim sistem melalui WA.</span>"
                            myStyle="margin: 0px -40px;"
                        >
                            <template v-slot:subtitle>
                                <p class="m-d-0 f-14">
                                    Setiap pengiriman akan <span class="f-bold">dikenakan biaya 100 mcoin.</span>
                                </p>
                            </template>
                        </SOInformation>
                    </div>
                    <div class="p-y-16" @click="hideSearchSelect2">
                        <SOInputSelect
                            class="p-d-12"
                            :title="'Ingatkan pada'"
                            :selected="selectedOptions"
                            :options="options"
                            :placeholder="'Pilih waktu...'"
                            @option-selected="onSelectOption"
                        />
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="p-x-20 p-y-16">
                    <SOButton :text="getBtnCaption" :outline="true" :full="true" @action="onSave" />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import SOInputSelect from "@/so-components/global/input/SOInputSelect";

import { moduleName } from "../../store/state";

export default {
    name: "UpdatePengingat",
    components: {
        SOSlotModal,
        SOInputSelect,
        SOButton,
        SOInformation,
    },
    data() {
        return {
            modalId: "modal-pengingat",
            page: {
                title: "Tambah Pengingat",
                loading: false,
            },
            options: [],
            selectedOptions: "",
        };
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            reminderOption: "reminderOption",
        }),
        ...mapGetters(moduleName, {
            reminders: "reminders",
        }),
        reminderId () {
            return this.$route.params.id;
        },
        isEdit() {
            return this.$route.name === "invoice.create.update_pengingat";
        },
        isExistReminder() {
            return (val) => {
                return this.reminders.find((rm) => rm === val) !== undefined;
            };
        },
        getTitle() {
            return this.isEdit ? "Ubah Pengingat" : this.page.title;
        },
        getBtnCaption() {
            return this.isEdit ? "Ubah" : "Tambah";
        },
    },
    methods: {
        ...mapActions({
            getReminderOption: `pengaturanUmumModule/getReminderOption`,
            setReminders: `${moduleName}/setReminders`,
            removeReminders: `${moduleName}/removeReminders`,
        }),
        async back(idx = -1) {
            await this.$router.go(idx);
        },
        async init() {
            await this.getReminderOption();
            await this.setOptions();
            if (this.isEdit) {
                await this.setSelectedOptions();
            }
        },
        setSelectedOptions() {
            this.selectedOptions = this.$route.params.id;
        },
        setOptions() {
            this.options = [];
            this.reminderOption.forEach((opt) => {
                this.options.push({
                    id: opt.id,
                    text: opt.nama.replace("Kadaluarsa", "Jatuh Tempo"),
                });
            });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        onSelectOption(value) {
            this.selectedOptions = value;
        },
        async onSave() {
            if (this.isExistReminder(this.selectedOptions) === false) {
                if (this.isEdit === true) {
                    await this.removeReminders(this.reminderId)
                }
                await this.setReminders(this.selectedOptions);
                this.back(-1);
            } else {
                this.$toast.warning('Reminder sudah dipasang!');
            }
        },
        hideSearchSelect2() {
            $(".select2-search").hide();
        },
    },
};
</script>
